import { useMemo } from 'react'
import { MdrModule } from '@/core/modules/mdr/mdr.module'
import { useMdrCasesQuery } from '@core/hooks/useMdrCasesQuery'
import { useCustomTheme } from '@/core/theme'

export const useAlertsOverview = () => {
    const theme: any = useCustomTheme()
    const { data } = useMdrCasesQuery()
    const timeRange = MdrModule.getTimeRange()
    const alerts = data
        ? MdrModule.processCases(data, timeRange)['alerts']
        : []

    const alertData = useMemo(
        () => ({
            critical: alerts.filter(
                (alert) => alert.severity.toLowerCase() === 'critical'
            ).length,
            high: alerts.filter(
                (alert) => alert.severity.toLowerCase() === 'high'
            ).length,
            medium: alerts.filter(
                (alert) => alert.severity.toLowerCase() === 'medium'
            ).length,
            low: alerts.filter(
                (alert) => alert.severity.toLowerCase() === 'low'
            ).length,
            informational: alerts.filter(
                (alert) => alert.severity.toLowerCase() === 'informational'
            ).length,
        }),
        [alerts]
    )

    const alertsConfig = useMemo(
        () => [
            {
                id: 'critical',
                label: 'Critical',
                value: alertData.critical,
                color: theme.colors.semantic.alertCritical,
            },
            {
                id: 'high',
                label: 'High',
                value: alertData.high,
                color: theme.colors.semantic.alertHigh,
            },
            {
                id: 'medium',
                label: 'Medium',
                value: alertData.medium,
                color: theme.colors.semantic.alertMedium,
            },
            {
                id: 'low',
                label: 'Low',
                value: alertData.low,
                color: theme.colors.semantic.alertLow,
            },
            {
                id: 'informational',
                label: 'Informational',
                value: alertData.informational,
                color: theme.colors.semantic.alertInfo,
                showInfo: true,
            },
        ],
        [alertData, theme]
    )

    const pieData = useMemo(
        () =>
            alertsConfig.map((alert) => ({
                name: alert.label,
                value: alert.value,
                color: alert.color,
            })),
        [alertsConfig]
    )

    const total = alerts.length
    const emptyPieColor = theme.colors.greys[75]
    const emptyPieBorderColor = theme.colors.greys[200]
    const isEmpty = total === 0
    const pieDataToShow = isEmpty
        ? [{ name: 'empty', value: 1, color: emptyPieColor }]
        : pieData

    return {
        alertsConfig,
        pieDataToShow,
        total,
        isEmpty,
        emptyPieBorderColor,
        theme,
        alerts,
    }
}

export { AlertsOverview } from './AlertsOverview'
